import { handlePromise } from "../apiControllers/helpers";
import Env from "../../Environments";
import { apiUrls } from "../../constants/apiUrls";

export const fetchUserInfo = async () => {
  const apiPayload = {
    method: "GET",
    url: Env.getLcoBasePath() + "lcoUserService/internal/user/get",
  };

  return handlePromise(apiPayload);
};

export const updateUserProfile = async (data) => {
  const apiPayload = {
    method: "POST",
    url: Env.getTeamIAMUrl() + apiUrls.updateUserProfile,
    data,
  };

  return handlePromise(apiPayload);
};

export const getPolicyDocuments = async (headers, data) => {
  const apiPayload = {
    method: "POST",
    data,
    headers,
    url: Env.getTeamOnboardUrl() + apiUrls.getPolicyDocuments,
  };

  return handlePromise(apiPayload);
};

export const getPolicy = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    url: Env.getTeamOnboardUrl() + apiUrls.getPolicy,
  };

  return handlePromise(apiPayload);
};

export const getContractDocuments = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    headers: { "x-source-config-id": "TEAM" },
    url: Env.getTeamContractBaseUrl() + apiUrls.getContractDocuments,
  };

  return handlePromise(apiPayload);
};

export const downloadContract = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    headers: { "x-source-config-id": "TEAM" },
    url: Env.getTeamContractBaseUrl() + apiUrls.downloadContractDocument,
  };

  return handlePromise(apiPayload);
};

export const downloadAddendum = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    headers: { "x-source-config-id": "TEAM" },
    url: Env.getTeamContractBaseUrl() + apiUrls.downloadAddendum,
  };

  return handlePromise(apiPayload);
};

export const getSoaDocument = async (params) => {
  const apiPayload = {
    method: "GET",
    params,
    url: Env.getLcoBasePath() + apiUrls.downloadSoa
  };
  return handlePromise(apiPayload);
};